exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".hwrld._2MWwq5HLsahA3yqTFVwmzE {\n  float: left;\n  padding: 20px;\n  width: 100%;\n}\n.hwrld._2MWwq5HLsahA3yqTFVwmzE ._3VtKQkmfiwtUk3icfUQUJ_ {\n  height: 70px;\n  margin: 0 auto 20px;\n  width: 70px;\n}\n.hwrld._2MWwq5HLsahA3yqTFVwmzE ._3vOgWttjzHh86o11DbQ1zb {\n  color: #00BCE4;\n  float: left;\n  font-size: 16px;\n  font-weight: bold;\n  margin-top: 20px;\n  text-align: center;\n  width: 100%;\n}", ""]);

// exports
exports.locals = {
	"hwrld": "_2MWwq5HLsahA3yqTFVwmzE",
	"spinning-wheel": "_3VtKQkmfiwtUk3icfUQUJ_",
	"text": "_3vOgWttjzHh86o11DbQ1zb"
};